module.exports = __webpack_public_path__ + "0101123e6788730428fa905ad95282f7.png";